module.exports = __webpack_public_path__ + "img/IC(8pins).5733748b.svg";